import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { Section } from './Section';
import { benefits } from '../data/content';
export function BenefitsSection() {
  return <Section eyebrow="Sección 4" title="Lo que vas a lograr hoy" data-id="element-15" data-mp="3iqzul6riyhyw">
      <ul className="grid gap-4 sm:grid-cols-2" data-id="element-16" data-mp="3npb6ro5al4ka">
        {benefits.map((benefit, index) => <motion.li key={benefit.title} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.4,
        delay: index * 0.07,
        ease: 'easeOut'
      }} className="flex gap-4 rounded-xl border border-ink-700 bg-ink-800 p-5" data-id="element-17" data-mp="3nn6vgl52d39z" data-mpi={index}>
            <span className="mt-0.5 inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-safe-500/15 text-safe-500" data-id="element-18" data-mp="34qp2y1ie4zco">
              <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-19" data-mp="12ysj84m2kj6t" />
            </span>
            <div data-id="element-20" data-mp="12wpr9f1cwfzg">
              <h3 className="font-display text-base font-bold text-white" data-id="element-21" data-mp="2bexh8vwawapi">{benefit.title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-slate-400" data-id="element-22" data-mp="27du3qg1q6qrg">{benefit.description}</p>
            </div>
          </motion.li>)}
      </ul>
    </Section>;
}